// Initialize trim directive.
export default {
  bind: function (el, binding, vnode) {
    // el might not be present for server-side rendering.
    if (el && el.tagName === 'INPUT') {
      // Set the element's background color.
      el.addEventListener('focusout', event => {
        event.target.value = event.target.value.trim()
        // force v-model update
        // https://stackoverflow.com/questions/49598541/how-to-modify-the-value-of-v-model-property-via-custom-directive
        vnode.elm.dispatchEvent(new CustomEvent('input'))
      })
    }
  }
}
